<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <h2>{{ labelService.getLabel(newPatientPanelTitle) }}</h2>
    <form [formGroup]="clientForm" class="client-form">
      <div class="patient-row">
        <mat-slide-toggle formControlName="is_patient">
          {{
            labelService.getLabel(
              "Vuoi associare questo cliente a un paziente?"
            )
          }}</mat-slide-toggle
        >

        @if (clientForm.get("is_patient")?.value) {
          <div class="patient-selector">
            <div class="selected-patient">
              <input
                [(ngModel)]="patientSearchText"
                (ngModelChange)="filterPatients($event)"
                (click)="onInputClick($event)"
                [placeholder]="labelService.getLabel('seleziona paziente')"
                class="patient-input"
                [ngModelOptions]="{ standalone: true }"
              />
              <mat-icon (click)="togglePatientsList()">{{
                showPatientsList ? "expand_less" : "expand_more"
              }}</mat-icon>
            </div>
            @if (showPatientsList) {
              <div class="patients-list">
                <div class="patients-scroll">
                  @for (patient of filteredPatients; track patient) {
                    <div
                      class="patient-item"
                      (click)="selectPatient(patient)"
                      [class.selected]="selectedPatient?.id === patient.id"
                    >
                      {{ patient.first_name }} {{ patient.last_name }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>

      <div class="form-columns-container">
        <div class="form-column">
          <div class="row-flex">
            <mat-form-field>
              <mat-label>{{ labelService.getLabel("Nome") }}</mat-label>
              <input matInput formControlName="client_first_name" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{ labelService.getLabel("Cognome") }}</mat-label>
              <input matInput formControlName="client_last_name" />
            </mat-form-field>
          </div>

          <div class="row-flex-email">
            <mat-form-field class="email">
              <mat-label>{{ labelService.getLabel("Email") }}</mat-label>
              <input matInput formControlName="client_email" />
            </mat-form-field>

            <mat-form-field class="number">
              <mat-label>{{ labelService.getLabel("Cellulare") }}</mat-label>
              <input matInput formControlName="client_number" />
            </mat-form-field>
          </div>

          <div class="row-single">
            <mat-form-field>
              <mat-label>{{
                labelService.getLabel("Codice Fiscale")
              }}</mat-label>
              <input matInput formControlName="client_tax_code" />
            </mat-form-field>
          </div>
        </div>

        <div class="form-column">
          <div class="row-flex-address">
            <mat-form-field class="address">
              <mat-label>{{ labelService.getLabel("Indirizzo") }}</mat-label>
              <input matInput formControlName="client_street_address" />
            </mat-form-field>

            <mat-form-field class="street-number">
              <mat-label>{{
                labelService.getLabel("Numero civico")
              }}</mat-label>
              <input matInput formControlName="client_street_number" />
            </mat-form-field>
          </div>

          <div class="row-flex">
            <mat-form-field>
              <mat-label>{{ labelService.getLabel("Città") }}</mat-label>
              <input matInput formControlName="client_city" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{ labelService.getLabel("Provincia") }}</mat-label>
              <input
                matInput
                formControlName="client_province"
                placeholder="Es. MI"
                maxlength="2"
              />
            </mat-form-field>
          </div>

          <div class="row-flex">
            <mat-form-field>
              <mat-label>{{ labelService.getLabel("CAP") }}</mat-label>
              <input matInput formControlName="client_zip_code" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{ labelService.getLabel("Paese") }}</mat-label>
              <mat-select formControlName="client_country">
                <input
                  matInput
                  (keyup)="filterCountries($event)"
                  placeholder="Cerca paese..."
                  #searchInput
                />
                @for (country of filteredCountries; track country) {
                  <mat-option [value]="country.name">
                    {{ country.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <div class="panel-buttons">
      <button class="button-white" mat-stroked-button (click)="onCancel()">
        {{ labelService.getLabel("cancel") }}
      </button>
      <button
        class="button-white"
        mat-raised-button
        (click)="onConfirm()"
        [disabled]="clientForm.invalid"
      >
        {{ labelService.getLabel("confirm") }}
      </button>
    </div>
  </div>
</div>
